import { Input } from "@/components/ui/input";
import { onlyDigits } from "@/lib/format";
import { cn } from "@/lib/utils";

export const MoneyInput = ({ value, onChange, className, testId, ...rest }) => (
  <div className="relative">
    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground font-mono text-sm">Rp</span>
    <Input
      inputMode="numeric"
      value={value ? Number(value).toLocaleString("id-ID") : ""}
      onChange={(e) => onChange(onlyDigits(e.target.value))}
      className={cn("pl-11 font-mono", className)}
      data-testid={testId}
      {...rest}
    />
  </div>
);

export const QuickAmounts = ({ onPick, amounts = [10000, 25000, 50000, 100000, 250000, 500000], testId = "quick-amount" }) => (
  <div className="flex flex-wrap gap-2">
    {amounts.map((a) => (
      <button key={a} type="button" onClick={() => onPick(String(a))} data-testid={`${testId}-${a}`}
        className="rounded-full border px-3.5 py-2 text-xs font-mono font-medium hover:border-primary hover:text-primary transition-colors min-h-[40px]">
        {a >= 1000000 ? `${a / 1000000}jt` : `${a / 1000}rb`}
      </button>
    ))}
  </div>
);
